<template>
  <div>
    <div class="post-image-section pointer">
      <div class="post-cover">
        <!-- INVISIBLE AVATAR -->
        <div class="avatar invisible d-none d-md-block"></div>
        <!-- INVISIBLE AVATAR -->

        <!-- IMAGE COLLAGES -->
        <div
          class="d-flex justify-content-between align-items-start nowrap position-relative w-100"
        >
          <!-- COLLAGE ONE -->
          <template v-if="post.attachments.length === 1">
            <template>
              <div
                class="img-container img-one-container overflow-hidden"
                @click="toggleViewer(0)"
              >
                <img
                  v-lazy="post.attachments[0].filename"
                  :alt="post.attachments[0].title"
                />
              </div>
            </template>

            <template v-if="subscription_status === false">
              <div class="img-lock-container index-9 locked">
                <div class="lock-caption">
                  <span class="icon-lock-fill font-15 border_grey_dark"></span>
                  <span class="title-text border_grey_dark font-weight-bold"
                    >Access Locked</span
                  >
                  <span class="meta-text my-4 border_grey_dark text-center"
                    >Contact your school admin for more Information</span
                  >
                </div>
              </div>
            </template>
          </template>
          <!-- COLLAGE ONE -->

          <!-- COLLAGE TWO -->
          <template v-if="post.attachments.length === 2">
            <div
              class="d-flex justify-content-between align-items-start nowrap position-relative"
            >
              <template>
                <div
                  class="img-container img-two-container overflow-hidden"
                  @click="toggleViewer(index)"
                  v-for="(image, index) in post.attachments"
                  :key="index"
                >
                  <img v-lazy="image.filename" :alt="image.title" />
                </div>
              </template>

              <template v-if="subscription_status === false">
                <div class="img-lock-container index-9 locked">
                  <div class="lock-caption">
                    <span
                      class="icon-lock-fill font-15 border_grey_dark"
                    ></span>
                    <span class="title-text border_grey_dark font-weight-bold"
                      >Access Locked</span
                    >
                    <span class="meta-text my-4 border_grey_dark text-center"
                      >Contact your school admin for more Information</span
                    >
                  </div>
                </div>
              </template>
            </div>
          </template>
          <!-- COLLAGE TWO -->

          <!-- COLLAGE THREE -->
          <template v-if="post.attachments.length === 3">
            <div
              class="d-flex justify-content-between align-items-start nowrap position-relative"
            >
              <template>
                <div
                  class="img-container img-two-container overflow-hidden"
                  @click="toggleViewer(0)"
                >
                  <img
                    v-lazy="post.attachments[0].filename"
                    :alt="post.attachments[0].title"
                  />
                </div>

                <div
                  class="img-two-container overflow-hidden d-flex flex-column justify-content-around align-items-end"
                >
                  <template>
                    <div
                      class="img-container img-three-container w-100"
                      @click="toggleViewer(1)"
                    >
                      <img
                        v-lazy="post.attachments[1].filename"
                        :alt="post.attachments[1].title"
                      />
                    </div>
                  </template>

                  <template>
                    <div
                      class="img-container img-three-container w-100"
                      @click="toggleViewer(2)"
                    >
                      <img
                        v-lazy="post.attachments[2].filename"
                        :alt="post.attachments[2].title"
                      />
                    </div>
                  </template>
                </div>
              </template>

              <template v-if="subscription_status === false">
                <div class="img-lock-container index-9 locked">
                  <div class="lock-caption">
                    <span
                      class="icon-lock-fill font-15 border_grey_dark"
                    ></span>
                    <span class="title-text border_grey_dark font-weight-bold"
                      >Access Locked</span
                    >
                    <span class="meta-text my-4 border_grey_dark text-center"
                      >Contact your school admin for more Information</span
                    >
                  </div>
                </div>
              </template>
            </div>
          </template>
          <!-- COLLAGE THREE -->

          <!-- COLLAGE FOUR -->
          <template v-if="post.attachments.length === 4">
            <div
              class="d-flex justify-content-between align-items-start flex-wrap position-relative"
            >
              <template>
                <div
                  class="img-container img-three-container img-four-container"
                  @click="toggleViewer(index)"
                  v-for="(image, index) in post.attachments"
                  :key="index"
                >
                  <img v-lazy="image.filename" :alt="image.title" />
                </div>
              </template>

              <template v-if="subscription_status === false">
                <div class="img-lock-container index-9 locked">
                  <div class="lock-caption">
                    <span
                      class="icon-lock-fill font-15 border_grey_dark"
                    ></span>
                    <span class="title-text border_grey_dark font-weight-bold"
                      >Access Locked</span
                    >
                    <span class="meta-text my-4 border_grey_dark text-center"
                      >Contact your school admin for more Information</span
                    >
                  </div>
                </div>
              </template>
            </div>
          </template>
          <!-- COLLAGE FOUR -->
        </div>
      </div>
    </div>

    <LibraryViewer
      v-if="show_viewer"
      file_type="image"
      :file_data="getImageData"
      :selected_image="selected_image"
      @closeTriggered="toggleViewer"
    ></LibraryViewer>
  </div>
</template>

<script>
import { formatDate, formatTime } from "@/scripts/utilities";

export default {
  name: "PostImageBlock",

  components: {
    LibraryViewer: () =>
      import(
        /* webpackChunkName: "LibraryViewer" */ "@/views/globalViews/LibraryViewer"
      ),
  },

  props: {
    post: Object,
    subscription_status: Boolean,
  },

  data() {
    return {
      show_viewer: false,
      selected_image: 0,
    };
  },

  computed: {
    getImageData() {
      return {
        title: this.post.attachments[0].title,
        url: this.post.attachments,
        token: this.post.attachments[0].token,
        date: this.formatImageDate(this.post.created_at),
        time: this.formatImageTime(this.post.created_at),
        fullname: this.post.user.full_name,
        image: this.post.user.image,
      };
    },
  },

  methods: {
    toggleViewer(index) {
      this.selected_image = index;
      this.show_viewer = !this.show_viewer;
    },

    formatImageDate(date) {
      return formatDate(date);
    },

    formatImageTime(date) {
      return formatTime(date);
    },
  },
};
</script>

<style lang="scss">
.post-image-section {
  padding: 8px 1px 10px;
  margin-top: 3px;
  position: relative;

  @include breakpoint_max(sm) {
    margin-left: 7px;
  }

  .post-cover {
    @include flex_row_start_nowrap;

    .avatar {
      margin-right: 10px;

      @include breakpoint_max(sm) {
        @include equal_min_edge(30);
      }
    }
  }

  .img-container {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    background: $brand_inverse_light;
    margin-bottom: 10px;
    height: 300px;
    border-radius: 5px;
    transition: all 0.4s ease-in-out;

    @include breakpoint_max(sm) {
      height: 220px;
    }

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .img-one-container {
    width: 100%;
  }

  .img-two-container {
    width: 49.8%;

    .title-text {
      font-size: 13px;
    }

    .meta-text {
      display: none;
    }
  }

  .img-three-container {
    height: 149.8px;
    margin-bottom: 2px;
    @include breakpoint_max(sm) {
      height: 109.8px;
    }
    .title-text {
      font-size: 14px !important;
    }

    .meta-text {
      display: none;
    }
  }

  .img-four-container {
    width: 49.8%;
    height: 149.8px;
    margin-bottom: 2px;
    @include breakpoint_max(sm) {
      height: 109.8px;
    }
    .title-text {
      font-size: 14px !important;
    }
    .meta-text {
      display: none;
    }
  }

  .img-lock-container {
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    @include section_stretch;
    height: auto;
    backdrop-filter: blur(6px);
    border-radius: 6px;
    overflow: hidden;
  }

  .lock-caption {
    @include transform_center;
    @include flex_column_center;
    z-index: 1;

    .title-text {
      margin-top: 12px;
      font-size: 15px;

      @include breakpoint_max(sm) {
        font-size: 14px;
      }

      @include breakpoint_max(xs) {
        font-size: 13px;
      }
    }

    .meta-text {
      font-size: 13px;
      line-height: 19px;

      @include breakpoint_max(sm) {
        font-size: 12px;
        line-height: 17px;
      }
      @include breakpoint_max(xs) {
        font-size: 11.5px;
        line-height: 16px;
        width: 150%;
      }
    }
  }

  .locked {
    cursor: not-allowed !important;
  }
}
</style>
